import { render, staticRenderFns } from "./clearing-prompt.vue?vue&type=template&id=15235ffe&scoped=true"
import script from "./clearing-prompt.vue?vue&type=script&lang=js"
export * from "./clearing-prompt.vue?vue&type=script&lang=js"
import style0 from "./clearing-prompt.vue?vue&type=style&index=0&id=15235ffe&prod&lang=css"
import style1 from "./clearing-prompt.vue?vue&type=style&index=1&id=15235ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15235ffe",
  null
  
)

export default component.exports